module.exports = __webpack_public_path__ + "img/1797.19e4bda7.jpg";